function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useEventListener } from '../_hooks/EventListener';
function noop() {}
var availableTriggers = ['click', 'hover', 'none', 'contextmenu', 'focus', 'always'];
export function triggerListeners(_ref) {
  var value = _ref.value,
    off = _ref.off,
    on = _ref.on,
    trigger = _ref.trigger,
    scope = _ref.scope;
  var targetTriggers = Array.isArray(trigger) ? trigger : [trigger];
  var handlerOrNoop = function handlerOrNoop(fn, trigger) {
    var isTargetTrigger = targetTriggers.includes(trigger);
    return {
      handler: isTargetTrigger ? fn : noop,
      noopHandler: !isTargetTrigger
    };
  };
  availableTriggers.forEach(function (trigger) {
    switch (trigger) {
      case 'click':
        var handler = handlerOrNoop(value ? off : on, trigger);
        useEventListener(_objectSpread({
          dependencies: [handler],
          event: 'click',
          scope: scope
        }, handler));
        break;
      case 'contextmenu':
        var ctxMenuHandler = handlerOrNoop(value ? off : on, trigger);
        useEventListener(_objectSpread({
          dependencies: [ctxMenuHandler],
          event: 'contextmenu',
          scope: scope
        }, ctxMenuHandler));
        break;
      case 'hover':
        var mouseLeaveHandler = handlerOrNoop(off, trigger);
        useEventListener(_objectSpread({
          event: 'mouseleave',
          scope: scope
        }, mouseLeaveHandler));
        var mouseEnterHandler = handlerOrNoop(on, trigger);
        useEventListener(_objectSpread({
          event: 'mouseenter',
          scope: scope
        }, mouseEnterHandler));
        break;
      case 'focus':
        var blurHandler = handlerOrNoop(off, trigger);
        useEventListener(_objectSpread({
          event: 'blur',
          scope: scope
        }, blurHandler));
        var focusHandler = handlerOrNoop(on, trigger);
        useEventListener(_objectSpread({
          event: 'focus',
          scope: scope
        }, focusHandler));
        break;
    }
  });
}
//# sourceMappingURL=triggerListeners.js.map